var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "social/outline/instagram"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Vector",
    x: 2.5,
    y: 2,
    width: 20,
    height: 20,
    rx: 4,
    stroke: "#FEFEFE",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Vector_2",
    cx: 18.5,
    cy: 6,
    r: 1,
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Vector_3",
    cx: 12.5,
    cy: 12,
    r: 5,
    stroke: "#FEFEFE",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramf);
export default __webpack_public_path__ + "static/media/instagramf.01a281a9ebb64c61bad585a2cde09fa2.svg";
export { ForwardRef as ReactComponent };